import MY_CONFIG from "@/constants";



export const getImageWithFallback = ({
  originalUrl,
  fallbackUrl = MY_CONFIG.LOGO_URL,
  alt = "",
  className = "",
}: {
  originalUrl?: string;
  fallbackUrl?: string;
  alt?: string;
  className?: string;
}) => (
  <img
    src={originalUrl?.trim() ? originalUrl : fallbackUrl}
    alt={alt}
    className={className}
    onError={(e) => {
      (e.currentTarget as HTMLImageElement).src = fallbackUrl;
    }}
  />
);